import React, { useState, useEffect, useRef } from 'react';

import { Modal } from 'flowbite';

import { modalOptions } from 'Helpers/modalOptions';

import Button from 'CommonComponents/Button';
import LoadingSpinner from 'CommonComponents/LoadingSpinner';
import ModalHeader from 'CommonComponents/ModalHeader';

export default function ExpenseAttachmentUploadIndex(props) {
    const [selectedFile, setSelectedFile] = useState(null);
    const [uploadedPath, setUploadedPath] = useState('');
    const [uploadedFileName, setUploadedFileName] = useState('');
    const [uploadedFileContentType, setUploadedFileContentType] = useState('');
    const [error, setError] = useState('');
    const [request, setRequest] = useState(false);
    const [uploaded, setUploaded] = useState(false);
    const [expenseAttachmentUploadIndexModalElement, setExpenseAttachmentUploadIndexModalElement] = useState(null);

    const expenseAttachmentUploadIndexModalRef = useRef();

    useEffect(() => {
        const modal = new Modal(expenseAttachmentUploadIndexModalRef.current, modalOptions(false));
        setExpenseAttachmentUploadIndexModalElement(modal);

        // Flowbite registers the modal under its element's id; a later mount (the side
        // panel reopened) would otherwise collide with the instance left behind.
        return () => modal.destroyAndRemoveInstance();
    }, []);

    const handleFileInput = (e) => {
        setSelectedFile(e.target.files[0]);
    };

    const showModal = () => {
        expenseAttachmentUploadIndexModalElement && expenseAttachmentUploadIndexModalElement.show();
    };
    const closeModal = () => {
        expenseAttachmentUploadIndexModalElement && expenseAttachmentUploadIndexModalElement.hide();
    };

    const uploadFile = (e, file) => {
        e.preventDefault();
        setRequest(true);

        let urlObj = new URL(props.getUploadUrl);
        let params = new URLSearchParams(urlObj.search);
        params.append('file_name', file.name);
        params.append('file_type', file.type);
        let url = urlObj.origin + urlObj.pathname + '?' + params.toString();

        axios
            .get(url)
            .then((res) => {
                const { url, path, fileName } = res.data;
                axios({
                    method: 'put',
                    url: url.url,
                    data: file,
                    headers: {
                        'Content-Type': file.type,
                        'Content-Disposition': 'inline',
                    },
                })
                    .then((response) => {
                        setUploadedPath(path);
                        setUploadedFileName(fileName);
                        setUploadedFileContentType(file.type);
                        setUploaded(true);
                        props.onUploaded?.();

                        if (props.expenseId) {
                            const linkUrl = props.linkAttachmentUrl.replace('EXPENSE_ID', props.expenseId);
                            axios
                                .put(linkUrl, {
                                    path: path,
                                    contentType: file.type,
                                })
                                .then((res) => {
                                    setTimeout(() => {
                                        closeModal();
                                        props.fetchAttachment();
                                    }, 1000);
                                })
                                .catch((e) => {
                                    console.log(e);
                                });
                        }
                    })
                    .catch((e) => {
                        console.log({ e });
                    });
            })
            .catch((e) => {
                setError(e?.response?.data);
            })
            .finally(() => {
                setRequest(false);
            });
    };

    return (
        <>
            <>
                {/* In-version read-only context: no attach affordance (IB-756). */}
                {!uploaded && !window.budgetReadOnly && (
                    <Button variant="primary" onClick={showModal}>
                        {$t('Attach Item')}
                    </Button>
                )}
                {uploaded && <span className="text-blue">{$t('Uploaded {{name}}', { name: selectedFile.name })}</span>}

                <input type="hidden" name="attachment_path" value={uploadedPath} />
                <input type="hidden" name="attachment_content_type" value={uploadedFileContentType} />
            </>
            <div id="upload-expense-file" ref={expenseAttachmentUploadIndexModalRef} tabIndex="-1" aria-hidden="true" className="hidden modal__box">
                <div className="modal__container">
                    <div className="modal__inner-container">
                        <ModalHeader title={$t('Choose file')} close={closeModal}></ModalHeader>
                        <div className="tw-rounded-b">
                            {request ? (
                                <LoadingSpinner />
                            ) : (
                                <div className="modal__form-container">
                                    {!request && !uploaded && (
                                        <div className="tw-grid tw-grid-cols-1">
                                            <div className="tw-flex tw-flex-col tw-space-y-1.5">
                                                <input
                                                    type="file"
                                                    className={error ? 'tw-border tw-border-red-500 file-input' : 'tw-border-0 file-input'}
                                                    id="expense-attachments"
                                                    placeholder="Select Files"
                                                    accept={props.acceptedFileTypes}
                                                    onChange={handleFileInput}
                                                />
                                                {error && <div className="tw-text-red-500 tw-text-sm">{$t('Invalid file type or extension')}</div>}
                                            </div>
                                        </div>
                                    )}
                                    {!request && uploaded && (
                                        <div className="tw-grid tw-grid-cols-1">
                                            <p className="modal__msg modal__text-color">
                                                {$t('The file {{name}} uploaded successfully', { name: uploadedFileName })}
                                            </p>
                                        </div>
                                    )}
                                    <div className="modal__footer">
                                        <Button variant="danger" onClick={closeModal} disabled={request}>
                                            {$t('Cancel')}
                                        </Button>
                                        {!uploaded && (
                                            <Button variant="primary" onClick={(e) => uploadFile(e, selectedFile)} disabled={request}>
                                                {$t('Upload file')}
                                            </Button>
                                        )}
                                        {uploaded && (
                                            <Button variant="primary" onClick={closeModal} disabled={request}>
                                                {$t('OK')}
                                            </Button>
                                        )}
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
